import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import AIInputComposer from '../components/AIInputComposer';
import { GENERATE_PREVIEW_OUTLINE } from '../graphql/mutations';

export default function PreviewGuidePage() {
  useDocumentTitle('Guide — apply pub');

  const [description, setDescription] = useState('');
  const navigate = useNavigate();

  const [generateOutline, { loading }] = useMutation(GENERATE_PREVIEW_OUTLINE);

  const handleSubmit = async (text: string) => {
    if (!text.trim()) return;
    try {
      const { data } = await generateOutline({ variables: { prompt: text } });
      const previewPlanId = data?.generatePreviewOutline?.id;
      if (previewPlanId) {
        navigate(`/preview/guide/${previewPlanId}`);
      }
    } catch (err) {
      console.error('Preview outline generation failed:', err);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 6, px: 2 }}>
      {/* Subtitle */}
      <Typography
        sx={{
          color: '#9CA3AF',
          fontSize: 15,
          mb: 4,
          textAlign: 'center',
        }}
      >
        Define and publish any application process.
      </Typography>

      {/* Prompt box */}
      <Box sx={{ width: '100%', maxWidth: 720 }}>
        <AIInputComposer
          value={description}
          onChange={setDescription}
          onSubmit={(text) => handleSubmit(text)}
          loading={loading}
          placeholder="Describe your application process..."
          hideAttachments
          hideMode
        />
      </Box>

      {/* Helper text */}
      <Typography
        sx={{
          color: '#9CA3AF',
          fontSize: 13,
          mt: 2.5,
          textAlign: 'center',
        }}
      >
        Describe the application process in plain language.
      </Typography>
    </Box>
  );
}
